import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import EndocrineAndrogensCombined from "./index";

const EndocrineAndrogensWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={EndocrineAndrogensCombined}
    keyControlsId="endocrine-androgens-key"
    {...props}
  />
);

export default EndocrineAndrogensWithToggleKey;
